// extracted by css-extract-rspack-plugin
export default {"root":"Q_dkXs","removed":"cEvqgE","btn-remove":"DJ1I77","btnRemove":"DJ1I77","selected":"_3MwWpU"};